import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { routes } from 'utils/routing';

import { DEFAULT_ICON as UnavailbleMenuTileIcon } from './icon';
import { BodyText, HeadingText, IconWrapper, Wrapper } from './menu-tile-unavailable.styled';

export const MenuTileUnavailable = () => {
  const { formatMessage } = useIntl();

  return (
    <Wrapper>
      {UnavailbleMenuTileIcon && (
        <IconWrapper>
          <UnavailbleMenuTileIcon />
        </IconWrapper>
      )}
      <HeadingText>{formatMessage({ id: 'menuTileUnavailableHeading' })}</HeadingText>
      <BodyText>{formatMessage({ id: 'menuTileUnavailableBody' })}</BodyText>
      <ActionButton to={routes.menu}>
        {formatMessage({ id: 'menuTileUnavailableButtonText' })}
      </ActionButton>
    </Wrapper>
  );
};
